import { render, staticRenderFns } from "./iqy.vue?vue&type=template&id=3976c1ef&scoped=true&"
import script from "./iqy.vue?vue&type=script&lang=js&"
export * from "./iqy.vue?vue&type=script&lang=js&"
import style0 from "./iqy.vue?vue&type=style&index=0&id=3976c1ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976c1ef",
  null
  
)

export default component.exports